export default __webpack_public_path__ + "ad607d0e1c9059fb8e2d20662eb26ce3.png";